module.exports = __webpack_public_path__ + "static/img/new_index_bg1.3ca180c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_index_bg1.png
// module id = t+oy
// module chunks = 1